import React from "react"
import ClassNames from "classnames"
import { Panel } from "components/organisms/panel"
import { IPODetail } from "components/organisms/panel/data"
import { APIResponse } from "redux/apis/types"
import { MainContainer } from "components/molecules/utils/mainContainer"
import { Labels } from "components/atoms/input/input"

type PropsType = {
  ipoDataList: {
    data: Array<APIResponse.Res>
    setData: Function
    currentPage: number
    changePage: Function
    ipoDataCategory: object
  }
  labelItem: {
    label: Array<{
      id: number
      name: string
    }>
    activeLabel: number
    changeLabel: Function
  }
  isPhone: boolean
  setRefreshFlag: Function
}

export const IPOTemplate: React.FC<PropsType> = props => {
  const { ipoDataList, labelItem, isPhone } = props
  const scrollElement = document.getElementById("scroll")
  return (
    <MainContainer className="domestic-container">
      <Panel
        title=""
        // refresh={() => props.setRefreshFlag(true)}
        className={ClassNames("panel-ipo-detail", {
          "is-phone": props.isPhone,
        })}
        filter={
          <Labels
            className="btn-segmented-control btn-thin liquid-control filter-control-item"
            labelList={labelItem.label}
            checked={labelItem.activeLabel}
            onChange={(id: number) => {
              labelItem.changeLabel(id)
              ipoDataList.changePage(0)
              scrollElement.scrollTo(0, 0)
            }}
          />
        }
      >
        <IPODetail ipoDataList={ipoDataList} isPhone={isPhone} />
      </Panel>
    </MainContainer>
  )
}
